import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const badges = ['+200 alumnas', 'Método probado', 'Resultados reales'];
export function WhoGuidesYou() {
  return <>
      <section className="py-20 md:py-28" style={{
      backgroundColor: '#2C1A0E'
    }} data-id="element-240">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-241">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="rounded-2xl p-6 md:p-10 flex flex-col sm:flex-row items-center sm:items-start gap-6 md:gap-8" style={{
          backgroundColor: '#3A2415',
          border: '1.5px solid #C9A96E'
        }} data-id="element-242">
            {/* Profile Photo */}
            <div className="flex-shrink-0" data-id="element-243">
              <div className="w-28 h-28 md:w-32 md:h-32 rounded-full overflow-hidden" style={{
              border: '3px solid #C9A96E',
              boxShadow: '0 0 20px rgba(201, 169, 110, 0.2)'
            }} data-id="element-244">
                <img src="https://cdn.magicpatterns.com/uploads/ghbD1DrKoQQStSymAmbzmn/TikTok_·_Pinch_of_Yum.jpg" alt="Catalina - Fundadora de La Cocina que Vende" className="w-full h-full object-cover" data-id="element-245" />
              </div>
            </div>

            {/* Text Content */}
            <div className="text-center sm:text-left" data-id="element-246">
              <h2 className="font-serif text-2xl md:text-3xl font-bold mb-4" style={{
              color: '#C9A96E'
            }} data-id="element-247">
                ¿Quién te guía?
              </h2>
              <p className="text-base md:text-lg leading-relaxed mb-6" style={{
              color: '#F5F0EB'
            }} data-id="element-248">
                Soy Catalina. Empecé vendiendo meriendas congeladas desde mi
                casa sin experiencia, sin local y sin inversión grande. En menos
                de dos años construí un sistema que ya ayudó a más de 200
                mujeres en toda Argentina a generar sus primeros ingresos reales
                cocinando desde casa.
              </p>

              {/* Trust Badges */}
              <div className="flex flex-wrap justify-center sm:justify-start gap-4 md:gap-6" data-id="element-249">
                {badges.map((badge, index) => <motion.div key={index} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.3 + index * 0.1
              }} className="flex items-center gap-2" data-id="element-250">
                    <CheckIcon className="w-4 h-4 flex-shrink-0" style={{
                  color: '#C9A96E'
                }} data-id="element-251" />
                    <span className="text-sm font-medium" style={{
                  color: '#F5F0EB'
                }} data-id="element-252">
                      {badge}
                    </span>
                  </motion.div>)}
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Sticky Bottom Bar */}
      <div className="fixed bottom-0 left-0 right-0 z-50 flex flex-col sm:flex-row items-center justify-between px-4 sm:px-6 py-3 gap-3 sm:gap-4" style={{
      backgroundColor: '#3A1010'
    }} data-id="element-253">
        <div className="flex items-center gap-2" data-id="element-254">
          <span className="text-lg" data-id="element-255">🔥</span>
          <span className="font-bold text-sm md:text-base" style={{
          color: '#E85D5D'
        }} data-id="element-256">
            Precio de lanzamiento — últimas horas
          </span>
        </div>
        <a href="#offer" className="font-bold text-sm md:text-base px-6 py-2.5 rounded-lg transition-opacity hover:opacity-90 whitespace-nowrap" style={{
        backgroundColor: '#C9A96E',
        color: '#2C1A0E'
      }} data-id="element-257">
          Quiero empezar ahora →
        </a>
      </div>
    </>;
}